import faker from 'faker';

const postalCodeFixture = {
  AT: { postalCode: '1090', city: 'Wien' },
  AU: { postalCode: '2000', city: 'Sydney' },
  BE: { postalCode: '1190', city: 'Forest' },
  CA: { postalCode: 'G1B0G5', city: 'Quebec' },
  DE: { postalCode: '10234', city: 'Berlin' },
  ES: { postalCode: '08001', city: 'Barcelona' },
  FI: { postalCode: '00640', city: 'Helsinki' },
  FR: { postalCode: '75012', city: 'Paris' },
  GB: { postalCode: 'SW19 6SQ', city: 'London' },
  IT: { postalCode: '90133', city: 'Palermo' },
  KI: { postalCode: 'KI0101', city: 'London' },
  NL: { postalCode: '1058 LX', city: 'Amsterdam' },
  NO: { postalCode: '0193', city: 'Oslo' },
  PL: { postalCode: '00-001', city: 'Warsaw' },
  SE: { postalCode: '111 34', city: 'Stockholm' },
  US: { postalCode: '85001', city: 'Phoenix', region: 'AZ' },
  PT: { postalCode: '1549-004', city: 'Lisboa' },
};

export const address = country => {
  const postalCode = postalCodeFixture[country] || {};
  return {
    street: faker.address.streetAddress(),
    country,
    postalCode: '8001',
    city: 'Zürich',
    ...postalCode,
  };
};
